class Site {
  static APP_NAME: string = import.meta.env.VITE_APP_NAME || "Upscale BD";
  static API_URL: string =
    import.meta.env.VITE_API_URL || "https://hrx-api.retail-x.org";
}

export default Site;
